import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { BRANCH_VIEW_KEY } from "@/lib/branchView";

/** Top-bar branch *view* (read filter). "all" = every branch; otherwise a branch id.
 *  The value travels on every API call as the `X-Branch-Id` header (see lib/api.js) and the
 *  backend only honours it for Company/Branch Admins. It never changes permissions.
 *  AuthContext writes the default at login (Company Admin → all, Branch Admin → own branch). */
const Ctx = createContext({ selected: "", setSelected: () => {} });

export function BranchViewProvider({ children }) {
  const { user } = useAuth();
  const [selected, setSel] = useState(() => localStorage.getItem(BRANCH_VIEW_KEY) || "");

  // The provider mounts before login, so re-read the stored value whenever the user changes.
  useEffect(() => { setSel(localStorage.getItem(BRANCH_VIEW_KEY) || ""); }, [user]);

  const setSelected = useCallback((id) => {
    try { localStorage.setItem(BRANCH_VIEW_KEY, id); } catch { /* ignore */ }
    setSel(id);
  }, []);
  return <Ctx.Provider value={{ selected, setSelected }}>{children}</Ctx.Provider>;
}

export const useBranchView = () => useContext(Ctx);
